import { render, staticRenderFns } from "./cost.vue?vue&type=template&id=230dc4da&scoped=true&"
import script from "./cost.vue?vue&type=script&lang=js&"
export * from "./cost.vue?vue&type=script&lang=js&"
import style0 from "./cost.vue?vue&type=style&index=0&id=230dc4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230dc4da",
  null
  
)

export default component.exports